import {hitAlgolytics} from "@pg-mono/algolytics";
import {getCrossPseudoId} from "@pg-mono/amplitude";

export const viewSessionTimeHit = (startTime: number, endTime: number, url: string, viewType: string | null) => {
    const isMobile = window.innerWidth < 1024;
    const crossPseudoId = getCrossPseudoId();

    const payload = {
        site: isMobile ? "Konto Mieszkaniowe Mobile" : "Konto Mieszkaniowe",
        site_id: isMobile ? 33 : 1,
        end_time: endTime,
        start_time: startTime,
        url,
        view_type: viewType,
        cross_pseudo_id: crossPseudoId ?? null
    };

    hitAlgolytics("tab_session_time", payload);
};
import {hitAlgolytics} from "@pg-mono/algolytics";
import {getCrossPseudoId} from "@pg-mono/amplitude";

export const viewSessionTimeHit = (startTime: number, endTime: number, url: string, viewType: string | null) => {
    const isMobile = window.innerWidth < 1024;
    const crossPseudoId = getCrossPseudoId();

    const payload = {
        site: isMobile ? "Konto Mieszkaniowe Mobile" : "Konto Mieszkaniowe",
        site_id: isMobile ? 33 : 1,
        end_time: endTime,
        start_time: startTime,
        url,
        view_type: viewType,
        cross_pseudo_id: crossPseudoId ?? null
    };

    hitAlgolytics("tab_session_time", payload);
};
